/**
 * http://usejsdoc.org/
 */
export default angular.module('mars.vet.dnareports.services.disorders', []).factory('DisorderDataService', function(UtilityService, disorderData, reportdata) {
    'ngInject';
    let resultString = reportdata.resultString;
    let petGender = reportdata.sampleDetails.petDetails.gender;
    let sampleDetails = reportdata.sampleDetails;

    var disorderDataList = {};
    var diseaseCategory = [];

    var atRiskData = [];
    var carrierData = [];
    var allClearData = [];
    var noCallData = [];

    const XLINKED   = "X-linked";
    const RECESSIVE = "autosomal recessive";
    const DOMINANT  = "autosomal dominant";
    const MITO  = "mitochondrial";

    const isAtRisk = (reportedDisorder) => {
      let disorder = disorderDataList[reportedDisorder.locusname];
      let modeOfInheritance = disorder.modeOfInheritance;

      if(modeOfInheritance  == XLINKED){
        if(reportedDisorder.copies == 2){
          return true;
        }
        // only applies if we have replaced copies 2 with copies 1:
        if (petGender == 'M' && reportedDisorder.copies == 1){
        	return true;
        }

      }
      else if(modeOfInheritance == RECESSIVE){
          return (reportedDisorder.copies == 2);
      }
      else if (modeOfInheritance == MITO) {
          return (reportedDisorder.copies == 2);
      }
      else if(modeOfInheritance == DOMINANT) {
          return (reportedDisorder.copies > 0);
      }

      return false; // safety net... will be true if XLINKED and copies<2, which is not what we want.
    };


    const isCarrier = (reportedDisorder) => {
      let disorder = disorderDataList[reportedDisorder.locusname];
      let modeOfInheritance = disorder.modeOfInheritance;

      if(modeOfInheritance  == XLINKED){
          return (petGender == 'F' && reportedDisorder.copies == 1);
      }
      else if(modeOfInheritance == RECESSIVE){
          return (reportedDisorder.copies == 1);
      }

      return false; // safety net, probably not needed.
    };


    const isAllClear = (reportedDisorder) => {
      return ((reportedDisorder.copies == 0));
    };

    const isNoCall = (reportedDisorder) => {
	  let disorder = disorderDataList[reportedDisorder.locusname];
      let modeOfInheritance = disorder.modeOfInheritance;

      if(reportedDisorder.copies == -1){ return true; }

      /**
      
      // condition not necessary if we have replaced copies 1 with -1 for X-linked M:
      if(modeOfInheritance  == XLINKED){
    	 if(petGender == 'M' && reportedDisorder.copies == 1){
      	   return true;
    	 }
      }
      // condition not necessary if we have replaced copies 1 with -1 for mitochondrial:
      else if(modeOfInheritance == MITO) {
          return (reportedDisorder.copies == 1);
      }
      **/

      return false; //this will be hit as the default case. for eample, if modeOfInheritance == XLINKED and gender is not F?
    };


    angular.forEach(disorderData, (value, key) => {
            let fields = value.fields;
            let oneCopyDesc = (petGender == 'M') ? fields.oneCopyMale : fields.oneCopyFemale;
            oneCopyDesc = oneCopyDesc.replaceAll ('[name]',sampleDetails.petDetails.petName).replaceAll ('[disease]',fields.diseaseName);

            let twoCopyDesc = (petGender == 'M') ? fields.twoCopyMale : fields.twoCopyFemale;
            twoCopyDesc = twoCopyDesc.replaceAll ('[name]',sampleDetails.petDetails.petName).replaceAll ('[disease]',fields.diseaseName);

            disorderDataList[fields.locusName] = {
                        'diseaseName': fields.diseaseName,
                        'entryId': value.sys.id,
                        'locusName': fields.locusName,
                        'enabled': fields.enabled,
                        'diseaseLongName': fields.diseaseLongName,
                        'diseaseCategory': fields.diseaseCategory,
                        'modeOfInheritance': fields.modeOfInheritance,
                        'vetandConsumerText': fields.vetandConsumerText,
                        'whatIsTheDisease': fields.whatIsTheDisease,
                        'clinicalDescription': fields.clinicalDescription,
                        'keySigns': fields.keySigns,
                        'onsetAge': fields.onsetAge,
                        'diseaseSeverity': fields.diseaseSeverity,
                        'likelihood': fields.likelihood,
                        'oneCopyDesc':oneCopyDesc,
                        'twoCopyDesc': twoCopyDesc
            };
      });

		angular.forEach(resultString.disorders, function(value, key) {
		  let disorder = disorderDataList[value.locusname];
		  if(!disorder){ console.log('no disorder'); return;}
		  if(disorder.enabled == false){return;}


		  /**

		  This replaces the value we received from the front end with the number of copies we want to tell people about:

		  only works if this method is called once, otherwise could change 2>1, then 1>-1.

		  **/

		  	  let modeOfInheritance = disorder.modeOfInheritance;

		  	  if(modeOfInheritance  == XLINKED && petGender == 'M'){
		  	  	if (value.copies == 1){
		  	  		value.copies = -1;
		  	  	}
		  	  	else if (value.copies == 2){
		  	  		value.copies = 1;
		  	  	}
		  	  }
		  	  else if (modeOfInheritance == MITO && value.copies == 1) {
		  	  	value.copies = -1;
		  	  }

		  /**

		  This initialises the display descriptions with the relevant value for the display number of copies.

		  Just need to use this value on the website.

		  I have updated partials atrisk.html to use this (text on the right hand side).

		  **/

		  if (value.copies == 1){
				disorder.displayDesc = disorder.oneCopyDesc;
		  }
		  else if (value.copies == 2){
				disorder.displayDesc = disorder.twoCopyDesc;
		  }


		  /**

		  This initialises the number of copy descriptions with the relevant value for the display number of copies.

		  Just need to use this value on the website.

		  I do not think this is the way you would  do this as we dont have access to the copyDescription text here which I would imagine you stuff into contentful.
		  I think you would much rather do the following:

		  <div ng-if="value['copies'] == 1" >{{hasOneCopyText}}</div>
		  <div ng-if="value['copies'] == 2" >
		  	<div ng-if="value['modeOfInheritance']!='mitochondrial'> {{hasTwoCopyText}}</div>
		  	<div ng-if="value['modeOfInheritance']!='mitochondrial'> {{hasSomeCopyText}}</div>
		  </div>

		  **/

		  	let numberCopiesOneText = "[name] has one copy of this mutation.".replaceAll ('[name]',sampleDetails.petDetails.petName);
		  	let numberCopiesTwoText = "[name] has two copies of this mutation.".replaceAll ('[name]',sampleDetails.petDetails.petName);
		  	let numberCopiesSomeText = "[name] has copies of this mutation.".replaceAll ('[name]',sampleDetails.petDetails.petName);

		  	  if (value.copies == 1){
					disorder.displayCopyText = numberCopiesOneText;
		  	  }
		  	  else if (value.copies == 2){

					disorder.displayCopyText = numberCopiesTwoText;

					if (modeOfInheritance == MITO){
						disorder.displayCopyText = numberCopiesSomeText;
					}
		  	  }




		  if(isNoCall(value)){noCallData.push(disorder); return;} //ticket # 2815
		  if(isAllClear(value)){allClearData.push(disorder); return;}
		  if(isCarrier(value)){carrierData.push(disorder);  return;}
		  if(isAtRisk(value)){atRiskData.push(disorder); return;}
		});



    return ({
        getAllClearData: function() {
            return allClearData;
        },
        getAtRiskData: function() {
            return atRiskData;
        },
        getCarrierData: function() {
            return carrierData;
        },
        getNoCallData: function() {
            return []; //DONOT Remove the logic ticket # 2815 
        },
        getDisorders: function() {
            return disorderDataList;
        }
    });

  }).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/disorderdata.service.js